module.exports = "<div class=\"chat-bubble border\"></div>";